// import React from 'react';
import FalconComponentCard from 'components/common/DSAFalconComponentCard';

import React, { useRef, useState, useEffect } from 'react';
// import * as echarts from 'echarts';

import { BarChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
// import { tooltipFormatter } from 'helpers/echart-utils';
import { useAppContext } from 'providers/AppProvider';
import ReactEchart from 'components/common/ReactEchart';
// import logo from 'components/dsp/logo.svg';
import { usePDF } from 'react-to-pdf';
import Button from 'react-bootstrap/Button';
// import ReactToPdf from 'react-to-pdf';
import generatePDF, { Resolution, Margin } from 'react-to-pdf';
// import { toPdf } from 'react-to-pdf';
// import * as echarts1 from 'echarts';
// import { interval } from 'd3';


// import axios from "axios";
// import { Document, Page, Text, pdf } from '@react-pdf/renderer';
// import { Buffer } from 'buffer';

// import { Document, Page, Text, pdf } from '@react-pdf/renderer';
// import ReactPDF, { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
// import {createReadStream} from 'fs'
// import { attachments } from 'data/kanban';
import emailjs from '@emailjs/browser';
// import { dspSubmit } from './eservicedsp';
// import e from 'cors';
// import { SMTPClient } from 'emailjs';
// import dspPdfFile from "./SelfPowermentReport-72.pdf";
// import emailjs from 'emailjs';
// import xtype from 'xtypejs';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
// import emailjs from 'emailjs-com';
import { useMediaQuery } from 'react-responsive';
import { PDFDocument } from "pdf-lib";
// import html2pdf from 'html2pdf.js';
//import html2pdf from 'html2pdf.js/dist/html2pdf.min.js';
// import { fontWeight } from 'html2canvas/dist/types/css/property-descriptors/font-weight';



echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
  LegendComponent
]);

const DSASeriesBarChart = (props) => {

  const [attachment, setAttachment, setSelectedBtn] = useState("");

  const useChartDimensions = () => {
    const isDesktop = useMediaQuery({ minWidth: 992 });
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 });
    const isMobile = useMediaQuery({ maxWidth: 767 });
    
    return { isDesktop, isTablet, isMobile };
  };
  // console.log(useChartDimensions());

  const { getThemeColor } = useAppContext();
  // const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });

  const { toPDF, targetRef } = usePDF({
    method: "save",
    filename: "SelfPowermentReportC.pdf",
    page: { margin: Margin.MEDIUM },
  });
  // const targetRef = React.useRef();
  // const pdfRef = useRef();
  

  // var dataChoice = [
  //   {name: 'Always', value: 100}, 
  //   {name: 'Usually' , value: 75}, 
  //   {name: 'Sometimes', value: 50},
  //   {name: 'Rarely', value: 25},
  //   {name: 'Never', value: 0} 
  // ];



// To verify, you would retrieve and parse it
// const isDark = JSON.parse(localStorage.getItem('dark'));

  useEffect(() => {
  window.addEventListener("message", (event) => {
    if (event.origin !== "http://10.1.27.133:3000") return;

    console.log(event.data);
  });
}, []);


  // This is how you set the value to the string "false" in localStorage
  localStorage.setItem('isDark', JSON.stringify(false));
  localStorage.setItem('theme', JSON.stringify("light"));

  const isDev = false;
  const measure_fontsize = useChartDimensions().isMobile ? 8 : 13.5; //strategy measurement guideline font size
  const measure_barwidth = 170; //total h-bar-data length
  const principle_offset = 35;
  const axis_max = 170; // axis 0-max

  // strategy name in h-bar font
  const barFontSize = useChartDimensions().isMobile ? 8 : 12; 
  const principleFontSize = useChartDimensions().isMobile ? 10 : 14;

  const font_weight = 'bold';
  const text_border_color = '#000';
  const text_border_weight = 1;

  //0: 1: 2: 3: 4: 5: 6: 7:Target zone
  const colors = ['#5470C6', '#aebaa8', '#EE6666', '#000000', '#ede7e7','#585656', '#ffffff', '#ec8484'];
  const barwidth = useChartDimensions().isMobile ? 30 : 50; // bar height
  const outcomesleft = useChartDimensions().isMobile ? '23%' : '75%'; //outcomes title
  const targetwidth = useChartDimensions().isMobile ? 1 : 275; //95 : 375;
  const targetz = useChartDimensions().isMobile ? '95' : '95'; // move target zone left or right
  const corepandsleft = useChartDimensions().isMobile ? '5%' : '4%';
  
  const outcomesh = useChartDimensions().isMobile ? '66%' : '77%';
  const outrectw = useChartDimensions().isMobile ? 120 : 240;
  const outrecth = useChartDimensions().isMobile ? 105 : 160;

  const labeldistance = useChartDimensions().isMobile ? 10 : 10; //Strategy label h alignment
   const principledistance = useChartDimensions().isMobile ? -10 : 10; //Principle label h alignment
  const cdistancer = useChartDimensions().isMobile ? -30 : 10; // Right continuum h alignment
  const lessSelfpoweredDistance = useChartDimensions().isMobile ? -13 : 10; // Left column h alignment
  const moreSelfpoweredDistance = useChartDimensions().isMobile ? -70 : 10; // Right column h alignment

  const continuum1l = useChartDimensions().isMobile ? 'Powers Underused\n or Overused ' : 'Powers Underused or Overused ';
  const continuum2l = useChartDimensions().isMobile ? 'Needs Deferred' : 'Needs Deferred';
  const continuum3l = useChartDimensions().isMobile ? 'Mind Crowded' : 'Mind Crowded';
  const continuum4l = useChartDimensions().isMobile ? 'Second-Guessing' : 'Second-Guessing';
  const continuum5l = useChartDimensions().isMobile ? 'Resisting Reality' : 'Resisting Reality';
  const continuum6l = useChartDimensions().isMobile ? 'Replaying \nDecisions' : 'Replaying Decisions';
  const continuum7l = useChartDimensions().isMobile ? 'Doing It Alone' : 'Doing It Alone';
  const continuum8l = useChartDimensions().isMobile ? 'Performing \nto Expectations' : 'Performing to Expectations';

  const continuum1r = useChartDimensions().isMobile ? 'Powers \nUsed Intentionally' : 'Powers Used Intentionally\t            \t';
  const continuum2r = useChartDimensions().isMobile ? 'Needs Honored\t     \t' : 'Needs Honored\t               \t            \t';
  const continuum3r = useChartDimensions().isMobile ? 'Mind Clear\t   \t     \t' : 'Mind Clear\t                  \t                 \t';
  const continuum4r = useChartDimensions().isMobile ? 'Self-Trusting\t   \t   \t' : 'Self-Trusting\t                  \t              \t';
  const continuum5r = useChartDimensions().isMobile ? 'Meeting Reality\t  \t' : 'Meeting Reality\t              \t              \t';
  const continuum6r = useChartDimensions().isMobile ? 'Standing in Choice\t' : 'Standing in Choice\t             \t         \t';
  const continuum7r = useChartDimensions().isMobile ? 'Supported by Trusted\n Connections' : 'Supported by Trusted Connections';
  const continuum8r = useChartDimensions().isMobile ? 'Being Who You Are\t \t' : 'Being Who You Are\t          \t           \t';

  const strategy1 = useChartDimensions().isMobile ? 'Supported by Trusted\n Connections' : 'Supported by Trusted Connections';
  const strategy2 = useChartDimensions().isMobile ? 'Supported by Trusted\n Connections' : 'Supported by Trusted Connections';
  const strategy3 = useChartDimensions().isMobile ? 'Supported by Trusted\n Connections' : 'Supported by Trusted Connections';
  const strategy4 = useChartDimensions().isMobile ? 'Supported by Trusted\n Connections' : 'Supported by Trusted Connections';
  const strategy5 = useChartDimensions().isMobile ? 'Supported by Trusted\n Connections' : 'Supported by Trusted Connections';
  const strategy6 = useChartDimensions().isMobile ? 'Supported by Trusted\n Connections' : 'Supported by Trusted Connections';
  const strategy7 = useChartDimensions().isMobile ? 'Supported by Trusted\n Connections' : 'Supported by Trusted Connections';
  const strategy8 = useChartDimensions().isMobile ? 'Being Who You Are\t \t' : 'Being Who You Are\t          \t           \t';

  const selfPoweredL = useChartDimensions().isMobile ? '{b|IN THE SUCCESS TRAP}' : '{b|IN THE SUCCESS TRAP}';
  const selfPoweredR = useChartDimensions().isMobile ? '{b|LIVING SELFPOWERED \t}' : '{b|LIVING SELFPOWERED \t\t}';

  const strategy = {
    ack: {
      gridright: 100,
      gridleft: useChartDimensions().isMobile ? '4%' : '3%',
      gridtop: 0,
      gridbottom: 0,
    },
    awaken: {
      gridright: 100,
      gridleft: useChartDimensions().isMobile ? '4%' : '3%',
      gridtop: 0,
      gridbottom: 0,
    },
    accept: {
      gridright: 100,
      gridleft: useChartDimensions().isMobile ? '4%' : '3%',
      gridtop: 0,
      gridbottom: 0,
    },
    align: {
      gridright: 100,
      gridleft: useChartDimensions().isMobile ? '4%' : '3%',
      gridtop: 0,
      gridbottom: '15%', 
    }
  };

  const devices = {
    mobile: {
      barwidth: 30,
      outcomesleft: '30%',
      targetwidth: 95,
      targetz: '75%',
      corepandsleft: '5%',
      labeldistance: 3,
      outcomesh: '66%',
      outrectw: 120,
      outrecth: 105,
    },
    desktop: {
      barwidth: 50,
      outcomesleft: '75%',
      targetwidth: 375,
      targetz: '44%',
      corepandsleft: '4%',
      labeldistance: 10,
      outcomesh: '77%',
      outrectw: 240,
      outrecth: 160,
    },
    tablet: {
      barwidth: 30,
      outcomesleft: '30%',
      targetwidth: 100,
      targetz: '35%',
      corepandsleft: '5%',
      labeldistance: 3,
      outcomesh: '66%',
      outrectw: 120,
      outrecth: 105,
    }
  };
  // console.log(device.mobile.barwidth);
  
  const qsv1 = [
    {id: 1, question: 'I am aware of my unique strengths, passions, and talents.', category: 'ack', state: 'harness'},
    {id: 2, question: 'I prioritize self-care as part of my daily routine.', category: 'ack', state: 'invest'},
    {id: 3, question: 'I listen to and trust my inner voice when making decisions.', category: 'awaken', state: 'trust'},
    {id: 4, question: 'I take responsibility for my actions and decisions, regardless of the outcome.', category: 'accept', state: 'own'},
    {id: 5, question: 'I have clarity in my purpose, even during challenging times.', category: 'awaken', state: 'trust'},
    {id: 6, question: 'I have learned to let go of things I cannot control and fully embrace the present moment.', category: 'accept', state: 'honor'},
    {id: 7, question: 'I build meaningful and uplifting connections in my personal and professional life.', category: 'align', state: 'connect'},
    {id: 8, question: 'I show up as my authentic self in the workplace.', category: 'align', state: 'be'},
    {id: 9, question: 'I cultivate a personal brand that reflects who I truly am.', category: 'align', state: 'be'},
    {id: 10, question: 'I focus on the moment without drifting into regrets about the past or worries about the future. ', category: 'accept', state: 'honor'},
    {id: 11, question: 'I feel at peace.', category: 'awaken', state: 'quiet'},
    {id: 12, question: 'I have clarity about my limiting beliefs and past experiences that may restrict my growth and potential and can manage them.', category: 'ack', state: 'harness'},
    {id: 13, question: 'I eat healthy and have a balanced diet.', category: 'ack', state: 'invest'},
    {id: 14, question: 'I am aware of my challenges, weaknesses, and areas where I struggle or don’t excel. ', category: 'ack', state: 'harness'},
    {id: 15, question: 'I engage in various activities that cultivate mindfulness and inner stillness/calmness. ', category: 'awaken', state: 'quiet'},
    {id: 16, question: 'I practice being present in the moment.', category: 'accept', state: 'honor'},
    {id: 17, question: 'I am intentional with my words and actions in professional communication.', category: 'align', state: 'be'},
    {id: 18, question: 'I have a network of allies, co-workers, sponsors, mentors I can always count on for support and guidance.', category: 'align', state: 'connect'},
    {id: 19, question: 'I embrace the reality that my career and life choices are ultimately mine to make.', category: 'accept', state: 'own'},
    {id: 20, question: 'I am not afraid to make decisions that could impact my career or financial situation.', category: 'accept', state: 'own'},
    {id: 21, question: 'I feel a sense of power from my wisdom.', category: 'awaken', state: 'trust'},
    {id: 22, question: 'I eﬀectively manage with ease both my personal and professional life.', category: 'accept', state: 'own'},
    {id: 23, question: 'I sense and feel the diﬀerences of “gut feelings” and factual logic.', category: 'awaken', state: 'trust'},
    {id: 24, question: 'I use my power of my breath to help bring calmness and ground me.', category: 'awaken', state: 'quiet'},
    {id: 25, question: 'I consciously can redirect my negative thoughts and feelings when my mind starts to spin.', category: 'awaken', state: 'quiet'},
    {id: 26, question: 'I recognize when I need a break and take time to nurture myself.', category: 'ack', state: 'invest'},
    {id: 27, question: 'I feel confident and ready to tackle any opportunity or challenge that comes my way.', category: 'ack', state: 'harness'},
    {id: 28, question: 'I believe in my full human capabilities, powers and my potential.', category: 'ack', state: 'harness'},
    {id: 28, question: 'I believe in investing in my mental, physical, and emotional needs.', category: 'ack', state: 'invest'},
    {id: 30, question: 'I intentionally cultivate a network of mentors and sponsors within my organization.', category: 'align', state: 'connect'},
    {id: 31, question: 'I feel comfortable asking for help or guidance from my network.', category: 'align', state: 'connect'},
    {id: 32, question: 'I align my professional actions with my authentic self.', category: 'align', state: 'be'},
    {id: 33, question: "I prioritize making choices for myself rather than prioritizing based on others' expectations or other beliefs or opinions.", category: 'accept', state: 'own'},
    {id: 34, question: 'I have a clear sense of my life’s purpose.', category: 'awaken', state: 'trust'},
    {id: 35, question: 'I set boundaries to protect my time and energy from being overextended.', category: 'ack', state: 'invest'},
    {id: 36, question: 'I invest in professional development to enrich my skills set in my career.', category: 'ack', state: 'harness'},
    {id: 37, question: 'I recognize when my mind becomes cluttered with negative self-talk or mental noise.', category: 'awaken', state: 'quiet'},
    {id: 38, question: 'I take time to evaluate how my daily life actions align with my life’s purpose.', category: 'awaken', state: 'trust'},
    {id: 39, question: 'I am accountable for my decisions and actions.', category: 'accept', state: 'own'},
    {id: 40, question: 'I believe in the power of honoring the present moment.', category: 'accept', state: 'honor'},
    {id: 41, question: 'I intentionally build relationships with peers, partners, mentors and sponsors outside of my organization.', category: 'align', state: 'connect'},
    {id: 42, question: 'I take mindful breaths to ground myself.', category: 'awaken', state: 'quiet'},
    {id: 43, question: 'I accept both the pleasant and challenging aspects of life without resistance.', category: 'accept', state: 'honor'},
    {id: 44, question: 'I prioritize getting enough sleep and maintaining a consistent sleep schedule.', category: 'ack', state: 'invest'},
    {id: 45, question: 'I make an eﬀort to attend events or activities that expand my network. ', category: 'align', state: 'connect'},
    {id: 46, question: 'I experience peace and gratitude by accepting what is.', category: 'accept', state: 'honor'},
    {id: 47, question: 'I strive to use the right tone and voice to create meaningful and positive influence.', category: 'align', state: 'be'},
    {id: 48, question: 'I am aligned in my current career with my life purpose.', category: 'align', state: 'be'},
    {id: 49, question: '', category: '', state: ''}
  ];

  const qs = [
    {id: 1, question: 'I am aware of my unique strengths, passions, and talents.', category: 'ack', state: 'harness'},
    {id: 2, question: 'I prioritize self-care as part of my daily routine.', category: 'ack', state: 'invest'},
    {id: 3, question: 'I listen to and trust my inner voice when making decisions.', category: 'awaken', state: 'trust'},
    {id: 4, question: 'I take responsibility for my actions and decisions, regardless of the outcome.', category: 'accept', state: 'own'},
    {id: 5, question: 'I have clarity about my purpose, even during challenging times.', category: 'awaken', state: 'trust'},
    {id: 6, question: 'I have learned to let go of things I cannot control and fully embrace the present moment.', category: 'accept', state: 'honor'},
    {id: 7, question: 'I build meaningful and uplifting connections in my personal and professional life.', category: 'align', state: 'connect'},
    {id: 8, question: 'I show up as my authentic self in the workplace.', category: 'align', state: 'be'},
    {id: 9, question: 'I cultivate a personal brand that reflects who I truly am.', category: 'align', state: 'be'},
    {id: 10, question: 'I focus on the moment without drifting into regrets about the past or worries about the future. ', category: 'accept', state: 'honor'},
    {id: 11, question: 'I feel at peace.', category: 'awaken', state: 'quiet'},
    {id: 12, question: 'I have clarity about my limiting beliefs and past experiences that may restrict my growth and potential and have learned manage them.', category: 'ack', state: 'harness'},
    {id: 13, question: 'I eat healthily and have a balanced diet.', category: 'ack', state: 'invest'},
    {id: 14, question: "I am aware of my challenges and weaknesses, including areas where I struggle or don't excel. ", category: 'ack', state: 'harness'},
    {id: 15, question: 'I engage in various activities that cultivate mindfulness and inner stillness. ', category: 'awaken', state: 'quiet'},
    {id: 16, question: 'I practice being present in the moment.', category: 'accept', state: 'honor'},
    {id: 17, question: 'I am intentional with my words and actions in professional communication.', category: 'align', state: 'be'},
    {id: 18, question: 'I have a network of allies, co-workers, sponsors, sponsors and mentors whom I can always count on for support and guidance.', category: 'align', state: 'connect'},
    {id: 19, question: 'I embrace the reality that my career and life choices are ultimately mine to make.', category: 'accept', state: 'own'},
    {id: 20, question: 'I am not afraid to make decisions that could impact my career or financial situation.', category: 'accept', state: 'own'},
    {id: 21, question: 'I feel a sense of power from my wisdom.', category: 'awaken', state: 'trust'},
    {id: 22, question: 'I eﬀectively manage both my personal and professional life with ease.', category: 'accept', state: 'own'},
    {id: 23, question: 'I sense the diﬀerences between “gut feelings” and factual logic.', category: 'awaken', state: 'trust'},
    {id: 24, question: 'I use the power of my breath to help bring calmness and to ground me.', category: 'awaken', state: 'quiet'},
    {id: 25, question: 'I am able to consciously redirect my negative thoughts and feelings when my mind starts to spin.', category: 'awaken', state: 'quiet'},
    {id: 26, question: 'I recognize when I need a break and take time to nurture myself.', category: 'ack', state: 'invest'},
    {id: 27, question: 'I feel confident and ready to tackle any opportunity or challenge that comes my way.', category: 'ack', state: 'harness'},
    {id: 28, question: 'I believe in my full human capabilities, powers and potential.', category: 'ack', state: 'harness'},
    {id: 29, question: 'I believe in investing in my mental, physical and emotional needs.', category: 'ack', state: 'invest'},
    {id: 30, question: 'I intentionally cultivate a network of mentors and sponsors within my organization.', category: 'align', state: 'connect'},
    {id: 31, question: 'I feel comfortable asking for help or guidance from my network.', category: 'align', state: 'connect'},
    {id: 32, question: 'I align my professional actions with my authentic self.', category: 'align', state: 'be'},
    {id: 33, question: "I prioritize making choices for myself rather than basing choices on others' expectations, beliefs or opinions.", category: 'accept', state: 'own'},
    {id: 34, question: 'I feel aligned with my life purpose and my current career.', category: 'awaken', state: 'trust'},
    {id: 35, question: 'I set boundaries to protect my time and energy from being overextended.', category: 'ack', state: 'invest'},
    {id: 36, question: 'I invest in professional development to enrich my skill-set in my career.', category: 'ack', state: 'harness'},
    {id: 37, question: 'I recognize when my mind becomes cluttered with negative self-talk or mental noise.', category: 'awaken', state: 'quiet'},
    {id: 38, question: 'I take time to evaluate how my daily life actions align with my life’s purpose.', category: 'awaken', state: 'trust'},
    {id: 39, question: 'I am accountable to myself first before others.', category: 'accept', state: 'own'},
    {id: 40, question: 'I believe in the power of honoring the present moment.', category: 'accept', state: 'honor'},
    {id: 41, question: 'I intentionally build relationships with peers, partners, mentors and sponsors outside of my organization.', category: 'align', state: 'connect'},
    {id: 42, question: 'I use breath work and or mediation techniques to quiet the noise in my head.', category: 'awaken', state: 'quiet'},
    {id: 43, question: 'I accept both the pleasant and challenging aspects of life without resistance.', category: 'accept', state: 'honor'},
    {id: 44, question: 'I prioritize getting enough sleep and maintaining a consistent sleep schedule.', category: 'ack', state: 'invest'},
    {id: 45, question: 'I make an eﬀort to attend events or activities that expand my network. ', category: 'align', state: 'connect'},
    {id: 46, question: 'I experience peace and gratitude by accepting what is.', category: 'accept', state: 'honor'},
    {id: 47, question: 'I strive to use the right tone and voice to create meaningful and positive influence.', category: 'align', state: 'be'},
    {id: 48, question: 'I am aligned with my life purpose in my current career.', category: 'align', state: 'be'},
    {id: 49, question: '', category: '', state: ''}
  ];

  var to = "info@scgrmm.com";
  var reply = "no-reply@scgrmm.com";
  var subject = "SELFPowerment Qs Report";
  var message = "Hello Deb!";
  var name = "Shenkson Apps - DSP";
  var bcc = "kevin.mcisaac.smith@gmail.com";
  var cc =  isDev ? 'kevin.mcisaac.smith@gmail.com' : 'deb@selfpowerment.com';

  const ejssend = 'https://api.emailjs.com/api/v1.0/email/send';
  const ejssendform = 'https://api.emailjs.com/api/v1.0/email/send-form';
  const micro3030e = "http://heliconia.scgrmm.com:3030/api/send";
  const micro3030i = "http://10.1.27.32:3030/api/send";



  // const [selectedFile, setSelectedFile] = useState(null);
  // const [base64String, setBase64String] = useState('');

  const  EJS_SERVICE_ID = "service_nhxx7zq";
  // const EJS_TEMPLATE_ID = "template_2t4azur";
  const EJS_TEMPLATE_ID = "template_1z4wr1t"; // prod2
  const EJS_PUBLIC_KEY = "1JyWi_f1dVaT-6WkD";

  // var  attachments = [
  //   {
  //     filename: "SelfPowerment Report1.pdf",
  //     contentType: 'application/pdf', // 'text/plain',
  //     content: dspPdfFile
  //   }
  // ];

  const formData = new FormData();
    formData.append('service_id', EJS_SERVICE_ID);
    formData.append('template_id', EJS_TEMPLATE_ID);
    formData.append('user_id', EJS_PUBLIC_KEY);
    formData.append('to', to);
    formData.append('from', reply);
    formData.append('subject', subject);
    formData.append('html', message);
    formData.append('name', name);
    formData.append('bcc', bcc);
    // formData.append('content', qs);

  // const dspparams = {  
  //   subject : subject,
  //   message : message,
  //   replyemail : reply,
  //   name : name,
  //   bcc : bcc,
  //   to : to,
  //   content: attachments[0]
  // };

  const qsa = "A completed Self Powerment report is attached.";

  const getAcknowledge = () => ({

    color: [getThemeColor('primary'), getThemeColor('info')],

      // tooltip: {
      //   trigger: 'axis',
      //   axisPointer: {
      //     type: 'shadow'
      //   },
      //   padding: [7, 10],
      //   backgroundColor: getThemeColor('gray-100'),
      //   borderColor: getThemeColor('gray-300'),
      //   textStyle: { color: getThemeColor('gray-1100') },
      //   borderWidth: 1,
      //   transitionDuration: 0,
      //   formatter: tooltipFormatter
      // },
      
      xAxis: {
        type: 'value',
        show: false,
        min: 0,
        max: axis_max,
        axisLabel: {
          rotate: isMobile ? 45 : 0,
          interval: isMobile ? 'auto' : 0,
          formatter: value => value / 1+'%',
          color: '#CC0033'
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: '#000000',
            type: 'solid'
          }
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: getThemeColor('gray-200')
          }
        }
      },

      // graphic: 
        
      //   [ 
      //     {
      //   type: 'text',
      //   z: 0,
      //   left: '-10%', // Left position
      //   top: '40',   // Floating above grid
      //   style: {
      //     text: 'Left Info Label',
      //     font: 'bolder 14px sans-serif',
      //     fill: '#000000'
      //   }
      // },
      // {
      //   type: 'text',
      //   z:0,
      //   right: '130%', // Right position
      //   top: '100',    // Floating above grid
      //   style: {
      //     text: 'Right Info Label',
      //     font: 'bolder 14px sans-serif',
      //     fill: '#000000'
      //   }
      // },


      // {
      //     type: 'group',
      //     left: outcomesh,
      //     top: '35%',
      //     children: [
      //       {
      //         type: 'rect',
      //         z: 100,
      //         left: 'center',
      //         top: 'middle',
      //         shape: {
      //           width: outrectw,
      //           height: outrecth
      //         },
      //         style: {
      //           opacity: .7,
      //           fill: '#fff',
      //           stroke: '#555',
      //           lineWidth: 1,
      //           shadowBlur: 8,
      //           shadowOffsetX: 3,
      //           shadowOffsetY: 3,
      //           shadowColor: 'rgba(0,0,0,0.2)'
      //         }
      //       },

      //       {
      //         // name: 'OUTCOMES',
      //         type: 'text',
      //         z: 100,
      //         left: 'center',
      //         top: 'middle',
      //         label: {
      //           show: true, position: 'insideLeft', fontSize: isMobile ? '12' : '18',
      //           distance: labeldistance, color: '#000000',
      //           formatter: ['TARGET ZONE: 62', '\nI am grounded with confidence',
      //           '\nI have clarity', '\nI know and love my “I am', '\n',
      //             '\nACTION:', '\nRelease your limiting belief'].join()
      //           },
      //         style: {
      //               fill: '#333',
      //               width: outrectw-20,
      //               overflow: 'break',
      //               text: ["I am grounded with confidence.\nI have clarity. \nI know and love my {b|I am}. \n\nACTION:{b|\nRelease} your limiting beliefs."],
      //               fontSize: isMobile ? 10 : 18,
      //               rich: {
      //                 b: {
      //                   fontFamily: 'Arial',
      //                   fontSize: isMobile ? 10 : 18,
      //                   fontWeight: 'italic bold'
      //                 }
      //               },
      //               font: '18px Arial'
      //             },
      //       }
      //     ]          
      //   },

      //   {
      //     // TOP - Target Zone Rectangle
      //     type: 'group',
      //     left: targetz,
      //     top: 'center',
      //     children: [
      //       {
      //         type: 'rect',
      //         z: 100,
      //         left: 'center',
      //         top: 'middle',
      //         shape: {
      //           width: targetwidth,
      //           height: 450
      //         },
      //         style: {
      //           opacity: .3,
      //           fill: '#fff',
      //           stroke: colors[2],
      //           lineWidth: 2,
      //           shadowBlur: 8,
      //           shadowOffsetX: 3,
      //           shadowOffsetY: 3,
      //           shadowColor: 'rgba(0,0,0,0.2)'
      //         }
      //       },

      //       {
      //         // name: 'TARGET ZONE',
      //         type: 'text',
      //         z: 600,
      //         left: 'center',
      //         top: 'bottom',
      //         color: colors[1] ,
      //         style: {
      //               fill: '#333',
      //               width: 220,
      //               overflow: 'break',
      //               text: isMobile ? 'TARGET ZONE\n\n\n\n\n\n\n\n' : 'TARGET ZONE\n\n\n\n\n\n\n\n',
      //               font: isMobile ? '12px Sans-Serif' : '15px Sans-Serif',
      //               color: '#4abb3b'
      //             },
      //       }
      //     ]          
      //   },

      //   {
      //     // SELFPOWERMENT OUTCOMES Title
      //     type: 'group',
      //     left: outcomesleft,
      //     top: 'center',
      //     children: [
      //       {
      //         type: 'rect',
      //         z: 100,
      //         left: 'center',
      //         top: 'middle',
      //         shape: {
      //           width: 515,
      //           height: 450
      //         },
      //         style: {
      //           color: '#000000',
      //           opacity: .1,
      //           fill: '#fff',
      //           // stroke: colors[2],
      //           // lineWidth: 2,
      //           // shadowBlur: 8,
      //           // shadowOffsetX: 3,
      //           // shadowOffsetY: 3,
      //           // shadowColor: 'rgba(0,0,0,0.2)'
      //         }
      //       },

      //       {
      //         // name: 'TARGET ZONE',
      //         type: 'text',
      //         z: 600,
      //         left: 'right',
      //         top: 'bottom',
      //         color: colors[1] ,
      //         style: {
      //               fill: '#333',
      //               width: 120,
      //               overflow: 'break',
      //               text: isMobile ? 'MORE SP\n\n\n\n\n\n\n\n' : 'MORE SELFPOWEREDMENT\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n',
      //               font: isMobile ? '12px Sans-Serif' : '15px Sans-Serif',
      //               color: '#4abb3b'
      //             },
      //       }
      //     ]          
      //   },

      //   {
      //     // CORE P&S Rectangle
      //     type: 'group',
      //     left: corepandsleft,
      //     top: 'center',
      //     children: [
      //       {
      //         type: 'rect',
      //         z: 100,
      //         left: 'left',
      //         top: 'middle',
      //         shape: {
      //           width: 515,
      //           height: 450
      //         },
      //         style: {
      //           opacity: .1,
      //           fill: '#fff',
      //           // stroke: colors[2],
      //           // lineWidth: 2,
      //           // shadowBlur: 8,
      //           // shadowOffsetX: 3,
      //           // shadowOffsetY: 3,
      //           // shadowColor: 'rgba(0,0,0,0.2)'
      //         }
      //       },

      //       {
      //         // name: 'TARGET ZONE',
      //         type: 'text',
      //         z: 600,
      //         left: 'center',
      //         top: 'bottom',
      //         // color: colors[1] ,
      //         style: {
      //               fill: '#333',
      //               width: 220,
      //               overflow: 'break',
      //               text: isMobile ? 'LESS SP\n\n\n\n\n\n\n\n' : 'LESS SELFPOWEREDMENT\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n',
      //               font: isMobile ? '12px Sans-Serif' : '15px Sans-Serif',
      //               color: '#4abb3b'
      //             },
      //       }
      //     ]          
      //   }
      
      // ],
 
      yAxis: [
        {
          type: 'category',
          data: ['Acknowledge', 'Harness', 'Invest'],
          show: false,
          name: 'PRINCIPLES & STRATEGIES',
          // position: 'right',
          // alignTicks: true,
          
      //     offset: 400,
      //     axisLine: {
      //       show: false,
      //       lineStyle: {
      //         color: colors[2]
      //       }
      // }
    }
    ],
      
      series: [
        { //Left Floating Label'
          name: 'Left Floating Label',
          type: 'bar',
          data: [null,null,200],
          barWidth: 10, //label height
          // barGap: '-100%',
          silent: true,
          label : {show: true, position: 'insideLeft', distance: lessSelfpoweredDistance,
            formatter: [selfPoweredL].join(),
            rich: {
              b: {
                fontWeight: 'bold',
                fontSize: isMobile ? '12' : 17,
                color: '#000000',
              }
            }
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 50,
            // borderWidth: 1,
            // borderType: 'solid',
            color: colors[6],
            // borderColor: colors[3],
            shadowColor: '',
            // shadowBlur: 0,
            opacity: 1
          },
        },
        { //Right Floating Label'
          name: 'Right Floating Label',
          type: 'bar',
          data: [null,null,200],
          barWidth: 10, //label height
          // barGap: '-4000%',
          silent: true,
          label : {show: true, position: 'insideRight',
            distance: moreSelfpoweredDistance,
            formatter: [selfPoweredR].join(),
            rich: {
              b: {
                fontWeight: 'bold',
                fontSize: isMobile ? '12' : 17,
                color: '#000000',
              }
            }
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 50,
            // borderWidth: 1,
            // borderType: 'solid',
            color: colors[6],
            // borderColor: colors[3],
            shadowColor: '',
            // shadowBlur: 0,
            opacity: 1
          },
        },    
        { //'ACKNOWLEDGE YOUR HUMAN-NESS'
          name: 'ACKNOWLEDGE YOUR HUMAN-NESS',
          color: '#FFFFFF',
          type: 'bar',
          data: [null,null,1],
          barWidth: '140%',
          // stack: 'principle',
          label : {show: true, color: '#CC0033', position: 'insideLeft', fontSize: principleFontSize,
            distance: principledistance,
            formatter: ['ACKNOWLEDGE YOUR HUMAN-NESS'].join()},
          markLine: {
            z: 0,
            symbol: 'none',
            silent: true, // prevents hover interaction
            lineStyle: {
              color: colors[7],
              width: 2,
              type: 'solid' // or 'dashed'
            },
            data: [
              { xAxis: targetz },
            ]
          }
        },
        { //Measure1 Right Bar
          name: 'Measure1 Right Bar',
          type: 'bar',
          data: [null,measure_barwidth,null],
          barWidth: barwidth,
          barGap: '-100%',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: cdistancer, color: '#000000',
            formatter: [continuum1r].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 50,
            // borderWidth: 1,
            // borderType: 'solid',
            color: colors[6],
            // borderColor: colors[3],
            shadowColor: '',
            // shadowBlur: 0,
            opacity: 1
          },
        },
        { //Measure2 Right Bar
          name: 'Measure2 Right Bar',
          type: 'bar',
          data: [measure_barwidth,null,null],
          barWidth: barwidth,
          barGap: '-100%',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: cdistancer, color: '#000000',
            formatter: [continuum2r].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 50,
            // borderWidth: 1,
            // borderType: 'solid',
            color: colors[6],
            // borderColor: colors[3],
            shadowColor: '',
            // shadowBlur: 0,
            opacity: 1
          },
        },
        { //Bar1 Offset
          name: 'Strategy1 Bar Offset',
          type: 'bar',
          stack: 'strategybar1',
          silent: true,
          data: [null, principle_offset, null],   // 👈 start point
          barWidth: barwidth,
          itemStyle: {
            color: 'transparent'
          },
        },
        { //Bar2 Offset
          name: 'Strategy1 Bar Offset',
          type: 'bar',
          stack: 'strategybar2',
          silent: true,
          data: [principle_offset, null, null],   // 👈 start point
          barWidth: barwidth,
          itemStyle: {
            color: 'transparent'
          },
        },
        { //Strategy1  Offset
          name: 'Strategy1  Offset',
          type: 'bar',
          stack: 'strategy1',
          silent: true,
          data: [null, principle_offset, null],   // 👈 start point
          barWidth: barwidth,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: labeldistance, color: '#000000',
            formatter: [continuum1l].join()
            },
          itemStyle: {
            color: 'transparent'
          },
        },
        { //Strategy2 Offset
          name: 'Strategy2 Offset',
          type: 'bar',
          stack: 'strategy2',
          silent: true,
          data: [principle_offset, null, null],   // 👈 start point
          barWidth: barwidth,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: labeldistance, color: '#000000',
            formatter: [continuum2l].join()
            },
          itemStyle: {
            color: 'transparent'
          },
          
          emphasis: { disabled: true },
          tooltip: { show: false }
        },
        { //Strategy1 Bar
          name: 'Strategy1 Bar',
          type: 'bar',
          data: [null,100,null],
          barWidth: barwidth,
          barGap: '-100%',
          stack: 'strategybar1',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? '12' : barFontSize,
            distance: labeldistance, color: '#000000',
            formatter: [''].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 50,
            // borderWidth: 1,
            borderType: 'solid',
            color: colors[4],
            // borderColor: colors[3],
            shadowColor: '',
            shadowBlur: 0,
            opacity: .5
          }
        },
        { //Strategy2 Bar
          name: 'Strategy2 Bar',
          type: 'bar',
          data: [100,null,null],
          barWidth: barwidth,
          barGap: '-100%',
          stack: 'strategybar2',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? '12' : barFontSize,
            distance: labeldistance, color: '#000000',
            formatter: [''].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 20,
            borderWidth: 1,
            borderType: 'solid',
            color:colors[4],
            // borderColor: colors[3],
            shadowColor: '',
            shadowBlur: 0,
            opacity: 0.5
          }
        },        
        { //Harness Your Powers
          name: 'Harness Your Powers',
          type: 'bar',
          data: [null,props.harness,null], //props.harness],
          barWidth: barwidth,
          stack: 'strategy1',
          silent: true,
          label : {show: true, position: 'insideLeft', fontSize: isMobile ? barFontSize : barFontSize,
            distance: labeldistance, color: colors[6],
            fontWeight: font_weight,
            textBorderColor: text_border_color, // Outline color
            textBorderWidth: text_border_weight,
            formatter: ['Harness Your Powers'].join()},
          // barPercentage: 1,
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 50,
            color: colors[5], //'#C7C7C7',
            shadowColor: '',
            // borderColor: colors[2],
            borderType: 'solid',
            shadowBlur: 0,
            opacity: 1
          }
        },
        { //Invest in Self Care
          name: 'Invest in Self Care',
          type: 'bar',
          data: [props.invest, null,null], //[props.invest],
          barWidth: barwidth,
          stack: 'strategy2',
          silent: true,
          label : {show: true, position: 'insideLeft', fontSize: isMobile ? barFontSize : barFontSize,
            distance: labeldistance, color: colors[6],
            fontWeight: font_weight,
            textBorderColor: text_border_color, // Outline color
            textBorderWidth: text_border_weight,
            formatter: ['Invest In Self-Care'].join()},
          itemStyle: {
            // borderRadius: [0, 50, 50, 0],
            barBorderRadius: 50,
            borderWidth: 1,
            borderType: 'solid',
            color: colors[5], //'#C7C7C7',
            // borderColor: colors[2],
            shadowColor: '',
            shadowBlur: 0,
            opacity: 1
          },
        },
      ], 
      
      grid: { right: strategy.ack.gridright, left: strategy.ack.gridleft, bottom: strategy.ack.gridbottom, top: strategy.ack.gridtop  },
    });

  const getAwaken = () => ({
      color: [getThemeColor('primary'), getThemeColor('info')],
        // tooltip: {
        //   trigger: 'axis',
        //   axisPointer: {
        //     type: 'shadow'
        //   },
        //   padding: [7, 10],
        //   backgroundColor: getThemeColor('gray-100'),
        //   borderColor: getThemeColor('gray-300'),
        //   textStyle: { color: getThemeColor('gray-1100') },
        //   borderWidth: 1,
        //   transitionDuration: 0,
        //   formatter: tooltipFormatter
        // },
        
        xAxis: {
          type: 'value',
          show: false,
          max: axis_max,
          axisLabel: {
            rotate: isMobile ? 45 : 0,
            interval: isMobile ? 'auto' : 0,
            formatter: value => value / 1+'%',
            color: '#CC0033'
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#000000',
              type: 'solid'
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: getThemeColor('gray-200')
            }
          }
        },
        graphic: 
        
        [
          // {
          // type: 'group',
          // left: outcomesh,
          // top: isMobile ? 20 : 60,
          // children: [
          //   {
          //     type: 'rect',
          //     z: 100,
          //     left: 'center',
          //     top: 'middle',
          //     borderRadius: 4,
          //     shape: {
          //       width: outrectw,
          //       height: outrecth
          //     },
          //     style: {
          //       opacity: .7,
          //       fill: '#fff',
          //       stroke: '#555',
          //       lineWidth: 1,
          //       shadowBlur: 8,
          //       shadowOffsetX: 3,
          //       shadowOffsetY: 3,
          //       shadowColor: 'rgba(0,0,0,0.2)'
          //     }
          //   },


            // {
            //   // name: 'TARGET ZONE',
            //   type: 'text',
            //   z: 100,
            //   left: 'center',
            //   top: 'middle',
            //   label: {
            //     show: true, position: 'insideLeft', fontSize: 18,
            //     distance: labeldistance, color: '#000000',
            //     formatter: ['TARGET ZONE: 62', '\nI am grounded with confidence',
            //     '\nI have clarity', '\nI know and love my “I am', '\n',
            //       '\nACTION:', '\nRelease your limiting belief'].join()
            //     },
            //   style: {
            //         fill: '#333',
            //         width: outrectw-20,
            //         overflow: 'break',
            //         text: 'I am centered within my {b|inner self}. \nI have stillness. \nI feel joy and peace. \n\nACTION: {b|\nTap into} the power of your breath.',
            //         fontSize: isMobile ? 10 : 18,
            //         rich: {
            //           b: {
            //             fontFamily: 'Arial',
            //             fontSize: isMobile ? 10 : 18,
            //             fontWeight: 'italic bold'
            //           }
            //         },
            //         font: '18px Arial'
            //       },
            // }
        //   ]
        // },
      
        {
          // Target Zone Rectangle
          type: 'group',
          left: targetz,
          top: 'center',
          children: [
            {
              type: 'rect',
              z: 100,
              left: 'center',
              top: 'middle',
              shape: {
                width: targetwidth,
                height: 450
              },
              style: {
                opacity: .3,
                fill: '#fff',
                stroke: colors[2],
                lineWidth: 2,
                shadowBlur: 8,
                shadowOffsetX: 3,
                shadowOffsetY: 3,
                shadowColor: 'rgba(0,0,0,0.2)'
              }
            },

            {
              // name: 'TARGET ZONE',
              type: 'text',
              // z: 600,
              left: 'center',
              top: 'bottom',
              style: {
                    fill: '#333',
                    width: 220,
                    overflow: 'break',
                    text: '',
                    font: '22px Microsoft YaHei'
                  },
            }
          ]          
        }
      ],
        
        // yAxis: {
        //   type: 'category',
        //   axisLine: {
        //     show: true,
        //     lineStyle: {
        //       color: getThemeColor('gray-300'),
        //       type: 'solid'
        //     }
        //   },
        //   axisLabel: {
        //     color: getThemeColor('gray-500')
        //   },
        //   axisTick: { show: false },
        //   splitLine: { show: false },
        //   data: ['']
        // },
        yAxis: [
          {
            type: 'category',
            name: 'Sales',
            data: ['Awaken', 'Quiet', 'Trust'],
            show: false,
            position: 'left'
          }
          // {
          //   type: 'category',
          //   name: 'TARGET ZONE',
          //   position: 'right',
          //   min: 0
          // }
        ],
        series: [
        {
            name: 'AWAKEN YOUR INNER BEING',
            color: '#FFFFFF',
            type: 'bar',
            data: [null,null,1],
            barWidth: '140%',
            label : {show: true, color: '#CC0033', position: 'insideLeft', fontSize: isMobile ? principleFontSize : principleFontSize,
              distance: principledistance,
              formatter: ['AWAKEN YOUR INNER BEING'].join()},
            itemStyle: {
              borderRadius: [0, 3, 3, 0],
              opacity: 1
            },
            markLine: {
              z: 0,
              symbol: 'none',
              silent: true, // prevents hover interaction
              lineStyle: {
                color: colors[7],
                width: 2,
                type: 'solid' // or 'dashed'
              },
              data: [
                { xAxis: targetz }
              ]
            }
        },
        { //Measure1 Right Bar
          name: 'Measure1 Right Bar',
          type: 'bar',
          data: [null,measure_barwidth,null],
          barWidth: barwidth,
          barGap: '-100%',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: cdistancer, color: '#000000',
            formatter: [continuum3r].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 50,
            // borderWidth: 1,
            // borderType: 'solid',
            color: colors[6],
            // borderColor: colors[3],
            shadowColor: '',
            // shadowBlur: 0,
            opacity: 1
          },
        },
        { //Measure2 Right Bar
          name: 'Measure2 Right Bar',
          type: 'bar',
          data: [measure_barwidth,null,null],
          barWidth: barwidth,
          barGap: '-100%',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: cdistancer, color: '#000000',
            formatter: [continuum4r].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 50,
            // borderWidth: 1,
            // borderType: 'solid',
            color: colors[6],
            // borderColor: colors[3],
            shadowColor: '',
            // shadowBlur: 0,
            opacity: 1
          },
        },
        { //Bar1 Offset
          name: 'Strategy1 Bar Offset',
          type: 'bar',
          stack: 'strategybar1',
          silent: true,
          data: [null, principle_offset, null],   // 👈 start point
          barWidth: barwidth,
          itemStyle: {
            color: 'transparent'
          },
        },
        { //Bar2 Offset
          name: 'Strategy1 Bar Offset',
          type: 'bar',
          stack: 'strategybar2',
          silent: true,
          data: [principle_offset, null, null],   // 👈 start point
          barWidth: barwidth,
          itemStyle: {
            color: 'transparent'
          },
        },
        { //Strategy1  Offset
          name: 'Strategy1  Offset',
          type: 'bar',
          stack: 'strategy1',
          silent: true,
          data: [null, principle_offset, null],   // 👈 start point
          barWidth: barwidth,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: labeldistance, color: '#000000',
            formatter: [continuum3l].join()
            },
          itemStyle: {
            color: 'transparent'
          },
        },
        { //Strategy2 Offset
          name: 'Strategy2 Offset',
          type: 'bar',
          stack: 'strategy2',
          silent: true,
          data: [principle_offset, null, null],   // 👈 start point
          barWidth: barwidth,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: labeldistance, color: '#000000',
            formatter: [continuum4l].join()
            },
          itemStyle: {
            color: 'transparent'
          },
          
          emphasis: { disabled: true },
          tooltip: { show: false }
        },
        { //Strategy1 Bar
          name: 'Strategy1 Bar',
          type: 'bar',
          data: [null,100,null],
          barWidth: barwidth,
          barGap: '-100%',
          stack: 'strategybar1',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? barFontSize : barFontSize,
            distance: labeldistance, color: '#000000',
            formatter: [''].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 50,
            // borderWidth: 1,
            borderType: 'solid',
            color: colors[4],
            // borderColor: colors[3],
            shadowColor: '',
            shadowBlur: 0,
            opacity: .5
          }
        },
        { //Strategy2 Bar
          name: 'Strategy2 Bar',
          type: 'bar',
          data: [100,null,null],
          barWidth: barwidth,
          barGap: '-100%',
          stack: 'strategybar2',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? barFontSize : barFontSize,
            distance: labeldistance, color: '#000000',
            formatter: [''].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 20,
            borderWidth: 1,
            borderType: 'solid',
            color:colors[4],
            // borderColor: colors[3],
            shadowColor: '',
            shadowBlur: 0,
            opacity: 0.5
          }
        },  
          { //'QUIET THE NOISES IN YOUR HEAD'
            name: 'QUIET THE NOISES IN YOUR HEAD',
            type: 'bar',
            barWidth: barwidth,
            stack: 'strategy1',
            silent: true,
            data: [null,props.quiet,null], //[props.quiet],
            label : {show: true, position: 'insideLeft', fontSize: isMobile ? barFontSize : barFontSize,
              distance: labeldistance, color: colors[6],
              fontWeight: font_weight,
              textBorderColor: text_border_color, // Outline color
              textBorderWidth: text_border_weight,
              formatter: ['Quiet the Noise In Your Head'].join()},
            itemStyle: {
              // borderRadius: [0, 50, 50, 0],
              barBorderRadius: 50,
              color: colors[5], //'#C7C7C7',
              shadowColor: '',
              // borderColor: colors[2],
              borderType: 'solid',
              shadowBlur: 0,
              opacity: 1
            },
            //  rich: {
            //   outlineStyle: {
            //     fontSize: 20,
            //     fontWeight: 'bold',
            //     color: '#fff', // Text color
            //     textBorderColor: '#000', // Outline color
            //     textBorderWidth: 3, // Outline width
            //     padding: [5, 10] // Optional padding
            //   }
            // }
          },
          { //'Trust In Your Intuition & Wisdom'
            name: 'Trust In Your Intuition & Wisdom',
            type: 'bar',
            data: [props.trust,null,null], //[props.trust],
            barWidth: barwidth,
            stack: 'strategy2',
            silent: true,
            label : {show: true, position: 'insideLeft', fontSize: isMobile ? barFontSize : barFontSize,
              distance: labeldistance, color: colors[6],
              fontWeight: font_weight,
              textBorderColor: text_border_color, // Outline color
              textBorderWidth: text_border_weight,
              formatter: ['Trust Your Intuition & Inner Wisdom'].join()},
            itemStyle: {
              // borderRadius: [0, 50, 50, 0],
              barBorderRadius: 50,
              borderWidth: 1,
              borderType: 'solid',
              color: colors[5],
              // borderColor: colors[2],
              shadowColor: '',
              shadowBlur: 0,
              opacity: 1
            }
          }
          // {
          //   name: 'TARGET ZONE',
          //   type: 'line',
          //   data: [62,62],
          //   yAxisIndex: 1 // Use the second Y-axis
          // }
        ], //Awaken
        grid: { right: strategy.awaken.gridright, left: strategy.awaken.gridleft, bottom: strategy.awaken.gridbottom, top: strategy.awaken.gridtop },
        // barCategoryGap: '30%',
        // grid: { right: '5%', left: '5%', bottom: '10%', top: '10%' },
        // media: [
        //   {
        //     query: { maxWidth: 767 },
        //     option: {
        //       series: [{ radius: ['40%', '60%'] }], // Smaller pie chart for mobile
        //       legend: { orient: 'horizontal', bottom: 0 },
        //     },
        //   },
        //   {
        //     query: { minWidth: 768 },
        //     option: {
        //       series: [{ radius: ['50%', '70%'] }], // Larger pie chart for desktop
        //       legend: { orient: 'vertical', right: 10 },
        //     },
        //   },
        // ],
      });

  const getAccept = () => ({
        color: [getThemeColor('primary'), getThemeColor('info')],
          // tooltip: {
          //   trigger: 'axis',
          //   axisPointer: {
          //     type: 'shadow'
          //   },
          //   padding: [7, 10],
          //   backgroundColor: getThemeColor('gray-100'),
          //   borderColor: getThemeColor('gray-300'),
          //   textStyle: { color: getThemeColor('gray-1100') },
          //   borderWidth: 1,
          //   transitionDuration: 0,
          //   formatter: tooltipFormatter
          // },
          
          xAxis: {
            type: 'value',
            show: false,
            max: axis_max,
            axisLabel: {
              rotate: isMobile ? 45 : 0,
              interval: isMobile ? 'auto' : 0,
              formatter: value => value / 1+'%',
              color: '#CC0033'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#000000',
                type: 'solid'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: getThemeColor('gray-200')
              }
            }
          },
          graphic: 
            
            [
              // {
              // type: 'group',
              // left: outcomesh,
              // top: isMobile ? 30 : 40,
              // children: [
              //   {
              //     type: 'rect',
              //     z: 100,
              //     left: 'center',
              //     top: 'middle',
              //     shape: {
              //       width: outrectw,
              //       height: outrecth
              //     },
              //     style: {
              //       opacity: .7,
              //       fill: '#fff',
              //       stroke: '#555',
              //       lineWidth: 1,
              //       shadowBlur: 8,
              //       shadowOffsetX: 3,
              //       shadowOffsetY: 3,
              //       shadowColor: 'rgba(0,0,0,0.2)'
              //     }
              //   },
    
    
                // {
                //   // name: 'TARGET ZONE',
                //   type: 'text',
                //   z: 100,
                //   left: 'center',
                //   top: 'middle',
                //   label: {
                //     show: true, position: 'insideLeft', fontSize: isMobile ? '12' : '18',
                //     distance: labeldistance, color: '#000000',
                //     formatter: ['TARGET ZONE: 62', '\nI am grounded with confidence',
                //     '\nI have clarity', '\nI know and love my “I am', '\n',
                //       '\nACTION:', '\nRelease your limiting belief'].join()
                //     },
                //   style: {
                //         fill: '#333',
                //         width: outrectw-20,
                //         overflow: 'break',
                //         text: 'I am empowered. \nI have choice. \nI feel the abundance of infinite possibilities. \n\nACTION: {b|\nLet go} of the uncontrollable things.',
                //         fontSize: isMobile ? 10 : 18,
                //         rich: {
                //           b: {
                //             fontFamily: 'Arial',
                //             fontSize: isMobile ? 10 : 18,
                //             fontWeight: 'italic bold'
                //           }
                //         },
                //         font: '18px Arial'
                //       },
                // }
            //   ]
            // },
          
            {
              // Target Zone Rectangle
              type: 'group',
              left: targetz,
              top: 'center',
              children: [
                {
                  type: 'rect',
                  z: 100,
                  left: 'center',
                  top: 'middle',
                  shape: {
                    width: targetwidth,
                    height: 450
                  },
                  style: {
                    opacity: .3,
                    fill: '#fff',
                    stroke: colors[2],
                    lineWidth: 2,
                    shadowBlur: 8,
                    shadowOffsetX: 3,
                    shadowOffsetY: 3,
                    shadowColor: 'rgba(0,0,0,0.2)'
                  }
                },
    
                {
                  // name: 'TARGET ZONE',
                  type: 'text',
                  // z: 600,
                  left: 'center',
                  top: 'bottom',
                  style: {
                        fill: '#333',
                        width: 220,
                        overflow: 'break',
                        text: '',
                        font: '22px Microsoft YaHei'
                      },
                }
              ]          
            }
          ],
          
          // yAxis: {
          //   type: 'category',
          //   axisLine: {
          //     show: true,
          //     lineStyle: {
          //       color: getThemeColor('gray-300'),
          //       type: 'solid'
          //     }
          //   },
          //   axisLabel: {
          //     color: getThemeColor('gray-500')
          //   },
          //   axisTick: { show: false },
          //   splitLine: { show: false },
          //   data: ['']
          // },
          yAxis: [
            {
              type: 'category',
              data: ['Accept', 'Honor', 'Own'],
              show: false,
              position: 'right',
            }
          ],
          series: [
          {
              name: 'ACCEPT THE MOMENT',
              color: '#FFFFFF',
              type: 'bar',
              data: [null,null,1],
              barWidth: '150%',
              label : {show: true, color: '#CC0033', position: 'insideLeft', fontSize: isMobile ? principleFontSize : principleFontSize,
                distance: principledistance,
                formatter: ['ACCEPT THE MOMENT'].join()},
              itemStyle: {
                borderRadius: [0, 3, 3, 0],
                opacity: 1
              },
              markLine: {
            z: 0,
            symbol: 'none',
            silent: true, // prevents hover interaction
            lineStyle: {
              color: colors[7],
              width: 2,
              type: 'solid' // or 'dashed'
            },
            data: [
              { xAxis: targetz }
            ]
          }
            },
                    { //Measure1 Right Bar
          name: 'Measure1 Right Bar',
          type: 'bar',
          data: [null,measure_barwidth,null],
          barWidth: barwidth,
          barGap: '-100%',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: cdistancer, color: '#000000',
            formatter: [continuum5r].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 50,
            // borderWidth: 1,
            // borderType: 'solid',
            color: colors[6],
            // borderColor: colors[3],
            shadowColor: '',
            // shadowBlur: 0,
            opacity: 1
          },
        },
        { //Measure2 Right Bar
          name: 'Measure2 Right Bar',
          type: 'bar',
          data: [measure_barwidth,null,null],
          barWidth: barwidth,
          barGap: '-100%',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: cdistancer, color: '#000000',
            formatter: [continuum6r].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 50,
            // borderWidth: 1,
            // borderType: 'solid',
            color: colors[6],
            // borderColor: colors[3],
            shadowColor: '',
            // shadowBlur: 0,
            opacity: 1
          },
        },
        { //Bar1 Offset
          name: 'Strategy1 Bar Offset',
          type: 'bar',
          stack: 'strategybar1',
          silent: true,
          data: [null, principle_offset, null],   // 👈 start point
          barWidth: barwidth,
          itemStyle: {
            color: 'transparent'
          },
        },
        { //Bar2 Offset
          name: 'Strategy1 Bar Offset',
          type: 'bar',
          stack: 'strategybar2',
          silent: true,
          data: [principle_offset, null, null],   // 👈 start point
          barWidth: barwidth,
          itemStyle: {
            color: 'transparent'
          },
        },
        { //Strategy1  Offset
          name: 'Strategy1  Offset',
          type: 'bar',
          stack: 'strategy1',
          silent: true,
          data: [null, principle_offset, null],   // 👈 start point
          barWidth: barwidth,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: labeldistance, color: '#000000',
            formatter: [continuum5l].join()
            },
          itemStyle: {
            color: 'transparent'
          },
        },
        { //Strategy2 Offset
          name: 'Strategy2 Offset',
          type: 'bar',
          stack: 'strategy2',
          silent: true,
          data: [principle_offset, null, null],   // 👈 start point
          barWidth: barwidth,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: labeldistance, color: '#000000',
            formatter: [continuum6l].join()
            },
          itemStyle: {
            color: 'transparent'
          },
          
          emphasis: { disabled: true },
          tooltip: { show: false }
        },
        { //Strategy1 Bar
          name: 'Strategy1 Bar',
          type: 'bar',
          data: [null,100,null],
          barWidth: barwidth,
          barGap: '-100%',
          stack: 'strategybar1',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? '12' : barFontSize,
            distance: labeldistance, color: '#000000',
            formatter: [''].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 50,
            // borderWidth: 1,
            borderType: 'solid',
            color: colors[4],
            // borderColor: colors[3],
            shadowColor: '',
            shadowBlur: 0,
            opacity: .5
          }
        },
        { //Strategy2 Bar
          name: 'Strategy2 Bar',
          type: 'bar',
          data: [100,null,null],
          barWidth: barwidth,
          barGap: '-100%',
          stack: 'strategybar2',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? '12' : barFontSize,
            distance: labeldistance, color: '#000000',
            formatter: [''].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 20,
            borderWidth: 1,
            borderType: 'solid',
            color:colors[4],
            // borderColor: colors[3],
            shadowColor: '',
            shadowBlur: 0,
            opacity: 0.5
          }
          },  
          {
            name: 'Honor What Is',
            type: 'bar',
            barWidth: barwidth,
            data: [null,props.honor,null],
            stack: 'strategy1',
            silent: true,
            label : {show: true, position: 'insideLeft', fontSize: isMobile ? barFontSize : barFontSize,
              distance: labeldistance, color: colors[6],
              fontWeight: font_weight,
              textBorderColor: text_border_color, // Outline color
              textBorderWidth: text_border_weight,
              formatter: ['Honor What Is'].join()},
            
            itemStyle: {
              // borderRadius: [0, 3, 3, 0],
              barBorderRadius: 50,
              color: colors[5],
              shadowColor: '',
              // borderColor: colors[2],
              borderType: 'solid',
              shadowBlur: 0,
              opacity: 1
            }
            },
            {
              name: 'Own Your Actions & Choices',
              type: 'bar',
              data: [props.own,null,null],
              barWidth: barwidth,
              stack: 'strategy2',
              silent: true,
              label : {show: true, position: 'insideLeft', fontSize: isMobile ? barFontSize : barFontSize,
                distance: labeldistance, color: colors[6],
                fontWeight: font_weight,
                textBorderColor: text_border_color, // Outline color
                textBorderWidth: text_border_weight,
                formatter: ['Own Your Actions & Choices'].join()},
              itemStyle: {
                // borderRadius: [0, 3, 3, 0],
                barBorderRadius: 50,
                borderWidth: 1,
                borderType: 'solid',
                color: colors[5],
                // borderColor: colors[2],
                shadowColor: '',
                shadowBlur: 0,
                opacity: 1
              }
              }
              // {
              //   name: 'TARGET ZONE',
              //   type: 'line',
              //   data: [62,62],
              //   yAxisIndex: 1 // Use the second Y-axis
              // }
            
          ], //Accept
          grid: { right: strategy.accept.gridright, left: strategy.accept.gridleft, bottom: strategy.accept.gridbottom, top: strategy.accept.gridtop }
          // grid: { right: '5%', left: '5%', bottom: '5%', top: '5%' },
          // media: [
          //   {
          //     query: { maxWidth: 767 },
          //     option: {
          //       series: [{ radius: ['40%', '60%'] }], // Smaller pie chart for mobile
          //       legend: { orient: 'horizontal', bottom: 0 },
          //     },
          //   },
          //   {
          //     query: { minWidth: 768 },
          //     option: {
          //       series: [{ radius: ['50%', '70%'] }], // Larger pie chart for desktop
          //       legend: { orient: 'vertical', right: 10 },
          //     },
          //   },
          // ],
        });

  const getAlign = () => ({
    color: [getThemeColor('primary'), getThemeColor('info')],
      
      page: {
        // margin is in MM, default is Margin.NONE = 0
        margin: Margin.SMALL,
        // default is 'A4'
        format: 'letter',
        // default is 'portrait'
        orientation: 'landscape',
     },

      // dataset: {
      //   dimensions: ['score', 'choice'],
      //   source: [
      //     ['score', 'choice'],
      //     [100, 'Always'],
      //     [75, 'Usually'],
      //     [50, 'Sometimes'],
      //     [25, 'Rarely'],
      //     [0, 'Never']
      //   ]
      // },
      
      xAxis: [
        {
        type: 'value',
        min: 0,
        axisTick: {
          alignWithLabel: true
        },
        // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
        // name: 'choice',
        show: true,
        interval: 5,
        max: axis_max,
        // encode: { x: 'choice', y: 'score' },
        axisLabel: {
          // rotate: isMobile ? 15 : 0,
          interval: isMobile ? 'auto' : 0,
          distance: 20,
          formatter: function(value){
            if (value==135)
              return 'Always'
            else if (value==110)
              return 'Usually'
            else if (value==85)
              return isMobile ? '50/50' : 'Sometimes 50/50'
            else if (value==60)
              return 'Rarely'
            else if (value==35)
              return 'Never'   //display series name
          },
          showMinLabel: true,
          showMaxLabel:true,
          // dimension: 1,
          // encode: { x: 'choice', y: 'score' },
          fontSize: isMobile ? 10 : 15,
          // interval: 25,
          // padding: 30,
          // margin: 20,
          // rotate: 30,
          // color: '#000000'
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: colors[2],
            type: 'solid'
          }
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: getThemeColor('gray-200')
          }
        }
      },
    //   {
    //     type: 'value',
    //     min: 0,
    //     max: 125
    //   },
    //   {
    //   type: 'value',
    //   min: 0,
    //   max: 125
    // }
    ],
      graphic: 
        
        [
          // {
          // type: 'group',
          // left: outcomesh,
          // top: isMobile ? 40 : 60,
          // children: [
          //   {
          //     type: 'rect',
          //     z: 100,
          //     left: 'center',
          //     top: 'middle',
          //     shape: {
          //       width: outrectw,
          //       height: outrecth
          //     },
          //     style: {
          //       opacity: .7,
          //       fill: '#fff',
          //       stroke: '#555',
          //       lineWidth: 1,
          //       shadowBlur: 8,
          //       shadowOffsetX: 3,
          //       shadowOffsetY: 3,
          //       shadowColor: 'rgba(0,0,0,0.2)'
          //     }
          //   },


            // {
            //   // name: 'Outcomes',
            //   type: 'text',
            //   z: 100,
            //   left: 'center',
            //   top: 'middle',
            //   style: {
            //         fill: '#333',
            //         width: outrectw-20,
            //         overflow: 'break',
            //         text: 'I am resilient. \nI have purpose. \nI feel at ease in my life and who {b|I am}. \n\nACTION: {b|\nStep into} your presence and voice.',
            //         fontSize: isMobile ? 10 : 18,
            //         rich: {
            //           b: {
            //             fontFamily: 'Arial',
            //             fontSize: isMobile ? 10 : 18,
            //             fontWeight: 'italic bold'
            //           }
            //         },
            //         font: '18px Arial'
            //       },
            // }
        //   ]
        // },

        {
          type: 'rect',
          shape: {
            x: 362, // Left side at x=62
            y: '20%', // 20% from the top of the chart
            width: 38, // Width is 100 - 62 = 38
            height: '60%', // 60% of the chart height
          },
          style: {
            fill: 'rgba(0, 150, 250, 0.3)',
            stroke: 'rgba(0, 150, 250, 0.7)',
          },
          // Optional: Add this if you want to make the rectangle draggable
          draggable: true,
          // Log the position after dragging
          // ondragend: function(params) {
          //   const xAxis = params.target.chartView.getAxis('x');
          //   const leftX = xAxis.toData(params.target.shape.x);
          //   const rightX = xAxis.toData(params.target.shape.x + params.target.shape.width);
          //   console.log('Left X:', leftX, 'Right X:', rightX);
          // }
        },

        {
          // Target Zone Rectangle
          type: 'group',
          left: targetz,
          top: 'center',
          children: [
            {
              type: 'rect',
              z: 100,
              left: 'center',
              top: 'middle',
              shape: {
                // x: 62,
                // y: '20%',
                width: targetwidth,
                height: 450
              },
              style: {
                opacity: .3,
                fill: '#fff',
                stroke: colors[2],
                lineWidth: 2,
                shadowBlur: 8,
                shadowOffsetX: 3,
                shadowOffsetY: 3,
                shadowColor: 'rgba(0,0,0,0.2)'
              }
            },

            {
              // name: 'TARGET ZONE',
              type: 'text',
              // z: 600,
              left: 'center',
              top: 'bottom',
              style: {
                    fill: '#333',
                    width: 220,
                    overflow: 'break',
                    text: '',
                    font: '22px Microsoft YaHei'
                  },
            }
          ]          
        }
      ],
  
      yAxis: [
       
        {
          type: 'category',
          data: ['Align', 'Connect', 'Be'],
          position: 'left',
          show: false
        },
        // {
        //   type: 'value',
        //   min: 0,
        //   max: 100
        // }
       
      ],

      series: [
      {
          name: 'ALIGN YOUR DOING',
          color: '#FFFFFF',
          type: 'bar',
          data: [null,null,1],
          barWidth: '150%',

          label : {show: true, color: '#CC0033', position: 'insideLeft', fontSize: isMobile ? principleFontSize : principleFontSize,
            distance: principledistance,
            formatter: ['ALIGN YOUR DOING'].join()},
          itemStyle: {
            borderRadius: [0, 3, 3, 0],
            opacity: 1
          },
          markLine: {
            z: 0,
            symbol: 'none',
            silent: true, // prevents hover interaction
            lineStyle: {
              color: colors[7],
              width: 2,
              type: 'solid' // or 'dashed'
            },
            data: [
              { xAxis: targetz }
            ]
          }
        },
        { //Measure1 Right Bar
          name: 'Measure1 Right Bar',
          type: 'bar',
          data: [null,measure_barwidth,null],
          barWidth: barwidth,
          barGap: '-100%',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: cdistancer, color: '#000000',
            formatter: [continuum7r].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 50,
            // borderWidth: 1,
            // borderType: 'solid',
            color: colors[6],
            // borderColor: colors[3],
            shadowColor: '',
            // shadowBlur: 0,
            opacity: 1
          },
        },
        { //Measure2 Right Bar
          name: 'Measure2 Right Bar',
          type: 'bar',
          data: [measure_barwidth,null,null],
          barWidth: barwidth,
          barGap: '-100%',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: cdistancer, color: '#000000',
            formatter: [continuum8r].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 50,
            // borderWidth: 1,
            // borderType: 'solid',
            color: colors[6],
            // borderColor: colors[3],
            shadowColor: '',
            // shadowBlur: 0,
            opacity: 1
          },
        },
        { //Bar1 Offset
          name: 'Strategy1 Bar Offset',
          type: 'bar',
          stack: 'strategybar1',
          silent: true,
          data: [null, principle_offset, null],   // 👈 start point
          barWidth: barwidth,
          itemStyle: {
            color: 'transparent'
          },
        },
        { //Bar2 Offset
          name: 'Strategy1 Bar Offset',
          type: 'bar',
          stack: 'strategybar2',
          silent: true,
          data: [principle_offset, null, null],   // 👈 start point
          barWidth: barwidth,
          itemStyle: {
            color: 'transparent'
          },
        },
        { //Strategy1  Offset
          name: 'Strategy1  Offset',
          type: 'bar',
          stack: 'strategy1',
          silent: true,
          data: [null, principle_offset, null],   // 👈 start point
          barWidth: barwidth,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: labeldistance, color: '#000000',
            formatter: [continuum7l].join()
            },
          itemStyle: {
            color: 'transparent'
          },
        },
        { //Strategy2 Offset
          name: 'Strategy2 Offset',
          type: 'bar',
          stack: 'strategy2',
          silent: true,
          data: [principle_offset, null, null],   // 👈 start point
          barWidth: barwidth,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? measure_fontsize : measure_fontsize,
            distance: labeldistance, color: '#000000',
            formatter: [continuum8l].join()
            },
          itemStyle: {
            color: 'transparent'
          },
          
          emphasis: { disabled: true },
          tooltip: { show: false }
        },
        { //Strategy1 Bar
          name: 'Strategy1 Bar',
          type: 'bar',
          data: [null,100,null],
          barWidth: barwidth,
          barGap: '-100%',
          stack: 'strategybar1',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? '12' : barFontSize,
            distance: labeldistance, color: '#000000',
            formatter: [''].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 50,
            // borderWidth: 1,
            borderType: 'solid',
            color: colors[4],
            // borderColor: colors[3],
            shadowColor: '',
            shadowBlur: 0,
            opacity: .5
          }
        },
        { //Strategy2 Bar
          name: 'Strategy2 Bar',
          type: 'bar',
          data: [100,null,null],
          barWidth: barwidth,
          barGap: '-100%',
          stack: 'strategybar2',
          silent: true,
          label : {show: true, position: 'insideRight', fontSize: isMobile ? '12' : barFontSize,
            distance: labeldistance, color: '#000000',
            formatter: [''].join()
            },
          itemStyle: {
            // borderRadius: [0,50, 50, 0],
            barBorderRadius: 20,
            borderWidth: 1,
            borderType: 'solid',
            color:colors[4],
            // borderColor: colors[3],
            shadowColor: '',
            shadowBlur: 0,
            opacity: 0.5
          }
        },  
        {
          name: 'Connect Intentionally',
          type: 'bar',
          barWidth: barwidth,
          stack:'strategy1',
          yAxisIndex: 0,
          silent: true,
          label : {show: true, position: 'insideLeft', fontSize: isMobile ? barFontSize : barFontSize,
            distance: labeldistance, color: colors[6],
            fontWeight: font_weight,
            textBorderColor: text_border_color, // Outline color
            textBorderWidth: text_border_weight,
            formatter: ['Connect Intentionally'].join()},
          data: [null,props.connect,null],
          itemStyle: {
            // borderRadius: [0, 3, 3, 0],
            barBorderRadius: 50,
            color: colors[5],
            shadowColor: '',
            // borderColor: colors[2],
            borderType: 'solid',
            shadowBlur: 0,
            opacity: 1
          }
        },
        {
          name: 'Create Your Future Self',
          type: 'bar',
          data: [props.be,null,null],
          barWidth: barwidth,
          stack: 'strategy2',
          yAxisIndex: 0,
          silent: true,
          label : {show: true, position: 'insideLeft', fontSize: isMobile ? barFontSize : barFontSize,
            distance: labeldistance, color: colors[6],
            fontWeight: font_weight,
            textBorderColor: text_border_color, // Outline color
            textBorderWidth: text_border_weight,
            formatter: ['Create Your Future Self'].join()},
          itemStyle: {
            // borderRadius: [0, 3, 3, 0],
            barBorderRadius: 50,
            borderWidth: 1,
            borderType: 'solid',
            color: colors[5],
            // borderColor: colors[2],
            shadowColor: '',
            shadowBlur: 0,
            opacity: 1
          }
        }
      ], // Align
      grid: { right: strategy.align.gridright, left: strategy.align.gridleft, bottom: strategy.align.gridbottom, top: strategy.align.gridtop },
      // grid: { right: '5%', left: '5%', bottom: '10%', top: '5%' },
      // grid: { right: '5%', left: '5%', bottom: '10%', top: '10%' },
      // media: [
      //   {
      //     query: { maxWidth: 767 },
      //     option: {
      //       series: [
      //         { 
      //           label: {fontSize: 12,},
      //           radius: ['40%', '60%'] }], // Smaller pie chart for mobile
      //       // legend: { orient: 'horizontal', bottom: 0 },
      //     },
      //   },
      //   {
      //     query: { minWidth: 768 },
      //     option: {
      //       series: [
      //         { 
      //           label: {fontSize: 18,},
      //           radius: ['50%', '70%'] }], // Larger pie chart for desktop
      //       // legend: { orient: 'vertical', right: 10 },
      //     },
      //   },
      // ],
    });

  const isMobile = useMediaQuery({ maxWidth: 767 });
  const options = {
    // default is `save`
    method: 'save',
    // default is Resolution.MEDIUM = 3, which should be enough, higher values
    // increases the image quality but also the size of the PDF, so be careful
    // using values higher than 10 when having multiple pages generated, it
    // might cause the page to crash or hang.
    resolution: Resolution.MEDIUM,
    page: {
        // margin is in MM, default is Margin.NONE = 0
        margin: Margin.SMALL,
        // default is 'A4'
        format: 'letter',
        // default is 'portrait'
        orientation: 'portrait',
    },
    canvas: {
        // default is 'image/jpeg' for better size performance
        mimeType: 'image/png',
        qualityRatio: 1
    },
    // Customize any value passed to the jsPDF instance and html2canvas
    // function. You probably will not need this and things can break, 
    // so use with caution.
    overrides: {
        // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
        pdf: {
          compress: true
        },
        // see https://html2canvas.hertzen.com/configuration for more options
        canvas: {
          useCORS: true
        }
    },
  };


  const getGeneratePdf = async () => {
    // const pdfBlb = await generatePDF(getTargetElement, { filename: 'SPReportPage.pdf'}, options)
    toPDF();
  };



  const sendPdf3 = async () => {

      try {

    const content = targetRef.current;

    const canvas = await html2canvas(content, {
      scale: isMobile ? 4 : 3,
    });

    const imgData = canvas.toDataURL('image/jpeg', 0.95);

    const imgWidth = canvas.width;
    const imgHeight = canvas.height;

    const pdf = new jsPDF({
      orientation: imgWidth > imgHeight ? 'l' : 'p',
      unit: 'px',
      // format: [8.5, 11],
      format: [imgWidth, imgHeight],
    });

    pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth,imgHeight);

    // Convert jsPDF to blob
    const reportBlob = pdf.output("blob");

    // Load both PDFs
    const reportArrayBuffer = await reportBlob.arrayBuffer();

    const guideBytes = await fetch("/docs/SELFPOWERMENT-SELF-ASSESSMENT-GUIDE.pdf")
      .then(res => res.arrayBuffer());

    // Create merged document
    const mergedPdf = await PDFDocument.create();

    const reportPdf = await PDFDocument.load(reportArrayBuffer);
    const guidePdf = await PDFDocument.load(guideBytes);

    // Copy report page
    const reportPages = await mergedPdf.copyPages(reportPdf, reportPdf.getPageIndices());
    reportPages.forEach((page) => mergedPdf.addPage(page));

    // Copy guide pages
    const guidePages = await mergedPdf.copyPages(guidePdf, guidePdf.getPageIndices());
    guidePages.forEach((page) => mergedPdf.addPage(page));

    const mergedBytes = await mergedPdf.save();
    setAttachment(mergedPdf);

    const pdfBlob = new Blob([mergedBytes], { type: "application/pdf" });
      
        // Convert blob to base64
        const base64data = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(pdfBlob);
        });

        
      
        // Prepare email data
        const emailData = {
          to: to,
          from: reply,
          replyemail: reply,
          cc: cc,
          subject: subject,
          name: name,
          message: 'Please find your PDF report attached.',
          content: base64data,
        };
      
        // Prepare micro email data
        const dformData = new FormData();
        dformData.append('to', to);
        dformData.append('from', reply);
        dformData.append('subject', subject);
        dformData.append('html', message);
        dformData.append('name', name);
        dformData.append('bcc', bcc);
        dformData.append('attachments', base64data);
  
       

        // Send email using EmailJS
        emailjs.send(EJS_SERVICE_ID, EJS_TEMPLATE_ID, emailData, EJS_PUBLIC_KEY)
          .then((result) => {
            // console.log('Email sent successfully:', result.text);
          }, (error) => {
            // console.error('Error sending email:', error.text);
          });

          // // Send email using Micro3030
          // const response = fetch(micro3030e, {
          //     method: 'POST',
          //     body: dformData,
          //   });
          //   const data = response;
          //   console.log('File uploaded successfully:', data);
          
      
      } catch (error) {
        console.error("Error generating PDF:", error);
      };
      // generatePDF(getTargetElement, { filename: 'SelfPowerment Assessment Report.pdf'}, options);
      // setTimeout(() => getGeneratePdf(), 700);
      // setTimeout(() => generatePDF(getTargetElement, { filename: 'SelfPowerment Assessment Report.pdf'}, options), 700);

      setTimeout(() => generatePDF(attachment,options), 700);
    };


  
    const sendPdf2 = async () => {
      try {
        const content = targetRef.current;
        
        // Get the actual dimensions of the content
        const contentWidth = content.scrollWidth;
        const contentHeight = content.scrollHeight;
      
        // Set up html2canvas options
        const html2canvasOptions = {
          scale: isMobile ? 4 : 3, // Increase scale for better quality
          width: contentWidth,
          height: contentHeight,
          scrollX: 0,
          scrollY: 0,
          windowWidth: contentWidth,
          windowHeight: contentHeight,
        };
      
        // Capture the content
        const canvas = await html2canvas(content, html2canvasOptions);
        const imgData = canvas.toDataURL('image/jpeg', 0.95); // Adjust quality if needed
      
        // Calculate PDF dimensions
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = imgWidth / imgHeight;
        
        const pdf = new jsPDF({
          orientation: ratio > 1 ? 'l' : 'p',
          unit: 'px',
          format: [imgWidth, imgHeight],
        });
      
        pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
        // pdf.addPage(dspPdfFile,'PDF',0,0,imgWidth,imgHeight);
        
      
        const pdfBlob = pdf.output('blob');
      
        // Check file size
        if (pdfBlob.size > 4 * 1024 * 1024) { // 4MB limit
          console.log("PDF file is too large to send via email. Please reduce content.");
          alert("PDF file is too large to send via email. Please reduce content.");
          return;
        }
      

        // // -------------------------------
        //  // Convert jsPDF to blob
        // const reportBlob = pdf.output("blob");

        // // Load both PDFs
        // const reportArrayBuffer = await reportBlob.arrayBuffer();

        // const guideBytes = await fetch("/docs/SELFPOWERMENT-SELF-ASSESSMENT-GUIDE.pdf")
        //   .then(res => res.arrayBuffer());

        // // Create merged document
        // const mergedPdf = await PDFDocument.create();

        // const reportPdf = await PDFDocument.load(reportArrayBuffer);
        // const guidePdf = await PDFDocument.load(guideBytes);

        // // Copy report page
        // const reportPages = await mergedPdf.copyPages(reportPdf, reportPdf.getPageIndices());
        // reportPages.forEach((page) => mergedPdf.addPage(page));

        // // Copy guide pages
        // const guidePages = await mergedPdf.copyPages(guidePdf, guidePdf.getPageIndices());
        // guidePages.forEach((page) => mergedPdf.addPage(page));

        // const mergedBytes = await mergedPdf.save();
        // setAttachment(mergedPdf);

        // // const pdfBlob = new Blob([mergedBytes], { type: "application/pdf" });


        // // -------------------------------


        // Convert blob to base64
        const base64data = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(pdfBlob);
        });
      
        // Prepare email data
        const emailData = {
          to: to,
          from: reply,
          replyemail: reply,
          cc: cc,
          subject: subject,
          name: name,
          message: 'Please find your PDF report attached.',
          content: base64data,
        };
      
        // Prepare micro email data
        const dformData = new FormData();
        dformData.append('to', to);
        dformData.append('from', reply);
        dformData.append('subject', subject);
        dformData.append('html', message);
        dformData.append('name', name);
        dformData.append('bcc', bcc);
        dformData.append('attachments', base64data);
  
       

        // Send email using EmailJS
        emailjs.send(EJS_SERVICE_ID, EJS_TEMPLATE_ID, emailData, EJS_PUBLIC_KEY)
          .then((result) => {
            // console.log('Email sent successfully:', result.text);
          }, (error) => {
            // console.error('Error sending email:', error.text);
          });

          // // Send email using Micro3030
          // const response = fetch(micro3030e, {
          //     method: 'POST',
          //     body: dformData,
          //   });
          //   const data = response;
          //   console.log('File uploaded successfully:', data);
          
      
      } catch (error) {
        console.error("Error generating PDF:", error);
      };
      // generatePDF(getTargetElement, { filename: 'SelfPowerment Assessment Report.pdf'}, options);
      // setTimeout(() => getGeneratePdf(), 700);
      setTimeout(() => generatePDF(getTargetElement, { filename: 'SelfPowerment Assessment Report.pdf'}, options), 700);
    };

    const useScreenOrientation = () => {
      const getOrientation = () => {
        if (window.matchMedia("(orientation: portrait)").matches) {
          return "portrait";
        }
        return "landscape";
      };

      const [orientation, setOrientation] = useState(getOrientation());

      useEffect(() => {
        const mediaQueryList = window.matchMedia("(orientation: portrait)");

        const handleOrientationChange = (e) => {
          setOrientation(e.matches ? "portrait" : "landscape");
        };

        // Use addEventListener for modern browsers
        mediaQueryList.addEventListener("change", handleOrientationChange);

        return () => {
          // Cleanup the event listener on component unmount
          mediaQueryList.removeEventListener("change", handleOrientationChange);
        };
      }, []);

      return orientation;
    };


    const getTargetElement = async () => { 

      // 1. Define the report element
      const reportObj = document.getElementById('spreport');

      // 2a. Generate PDF from DOM element (using html2pdf)
      // 816x1056 - 96 DPI (screen) or 612x792 - 72 DPI (screen)
      const canvas = await html2canvas(reportObj, {
        scale: isMobile ? 5.7 : 2,
      });
      
      const imgData = canvas.toDataURL('image/jpeg', 0.99);
      const imgWidth = canvas.width/5.5; console.log(imgWidth);
      const imgHeight = canvas.height/5.5; console.log(imgHeight);
      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'px',
        format: [imgWidth, imgHeight],
      });
      pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth,imgHeight);
      const reportPdfBlob = pdf.output('blob');


      // 2b. Generate PDF from DOM element (using html2pdf)
      // const reportPdfBlob = await html2pdf()
      // .from(reportObj)
      // .toPdf()
      // .outputPdf('blob');

      // 3. Load your guide PDF
      const guideURL = '/docs/SELFPOWERMENT-SELF-ASSESSMENT-GUIDE.pdf';
      const existingPdfBytes = await fetch(guideURL).then(res => res.arrayBuffer());

      // 4. Merge PDFs using pdf-lib
      const mergedPdf = await PDFDocument.create();
      const reportPdf = await PDFDocument.load(await reportPdfBlob.arrayBuffer());
      const guidePdf = await PDFDocument.load(existingPdfBytes);

      // Copy pages from both docs
      const reportPages = await mergedPdf.copyPages(reportPdf,reportPdf.getPageIndices());
      reportPages.forEach(page => mergedPdf.addPage(page));
      
      const guidePages = await mergedPdf.copyPages(guidePdf, guidePdf.getPageIndices());
      guidePages.forEach(page => mergedPdf.addPage(page));


      // 5. Save and Download
      const mergedPdfBytes = await mergedPdf.save();
      const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'SelfPowerment Assessment Report.pdf';
      link.click();

      // Check file size
      if (reportPdfBlob.size > 4 * 1024 * 1024) { // 4MB limit
        console.log("PDF file is too large to send via email. Please reduce content.");
        alert("PDF file is too large to send via email. Please reduce content.");
        return;
      };

      // Convert blob to base64
        const base64data = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(reportPdfBlob);
        });
      
        // Prepare email data
        const emailData = {
          to: to,
          from: reply,
          replyemail: reply,
          cc: cc,
          subject: subject,
          name: name,
          message: 'Please find your PDF report attached.',
          content: base64data,
        };
      
        // Prepare micro email data
        const dformData = new FormData();
        dformData.append('to', to);
        dformData.append('from', reply);
        dformData.append('subject', subject);
        dformData.append('html', message);
        dformData.append('name', name);
        dformData.append('bcc', bcc);
        dformData.append('attachments', base64data);
       
        // Send email using EmailJS
        emailjs.send(EJS_SERVICE_ID, EJS_TEMPLATE_ID, emailData, EJS_PUBLIC_KEY)
          .then((result) => {
            // console.log('Email sent successfully:', result.text);
          }, (error) => {
            // console.error('Error sending email:', error.text);
          });

          // // Send email using Micro3030
          // const response = fetch(micro3030e, {
          //     method: 'POST',
          //     body: dformData,
          //   });
          //   const data = response;
          //   console.log('File uploaded successfully:', data);
          



       // Convert jsPDF to blob
        // const reportBlob = pdf.output("blob");

        // Load both PDFs
        // const reportArrayBuffer = await reportObj.arrayBuffer();

        // const guideBytes = await fetch("/docs/SELFPOWERMENT-SELF-ASSESSMENT-GUIDE.pdf")
        //   .then(res => res.arrayBuffer());

        // // Create merged document
        // const mergedPdf = await PDFDocument.create();

        // // const reportPdf = await PDFDocument.load(reportArrayBuffer);
        // const guidePdf = await PDFDocument.load(guideBytes);

        // // Copy report page
        // const reportPages = await mergedPdf.copyPages(reportPdf, reportPdf.getPageIndices());
        // reportPages.forEach((page) => mergedPdf.addPage(page));

        // // Copy guide pages
        // const guidePages = await mergedPdf.copyPages(guidePdf, guidePdf.getPageIndices());
        // guidePages.forEach((page) => mergedPdf.addPage(page));

        // const mergedBytes = await mergedPdf.save();
        // setAttachment(mergedPdf);

        // const pdfBlob = new Blob([mergedBytes], { type: "application/pdf" });
        // return pdfBlob;

    };

    // const logooption = isMobile ? logosp : logosp;

    return (
      <>
      {/* <div ref={chartRef} style={{ width: '100%', height: '500px' }} /> */}
      {/* onClick={() => generatePDF(getTargetElement, options)} */}

      {/* <Lottie animationData={infiniteLoop} loop={true}  style={{height: '120px', width: '120px'}} /> */}
      <FalconComponentCard className={"fs-10 h-0 w-auto " + (useChartDimensions().isMobile ? 'mt-3' : 'mt-3')}>
      {/* <Button  onClick={sendEmailJSSMTP} variant='danger' className='me-2 mb-1'>PRINT/VIEW PDF</Button> */}
      {/* <Button  onClick={sendEmailWithPDF} variant='danger' className='me-2 mb-1'>sendEmailWithPDF</Button> */}
      {/* <Button  onClick={handleFetchSubmit} variant='danger' className='me-2 mb-1'>Fetch Email PDF</Button> */}
      <Button  onClick={getTargetElement} variant='danger' className='me-2 fs-6 mb-1'>DOWNLOAD/VIEW PDF</Button>
      {/* <Button  onClick={sendReportEJS} variant='danger' className='me-2 mb-1'>sendReportEJS</Button> */}
      {/* <Button  onClick={submitFormProgrammatically} variant='danger' className='me-2 mb-1'>submitFormProgrammatically</Button> */}
      {/* <button onClick={generateAndStorePDF}>Generate and Store PDF</button>
      {pdfBlob && <p>PDF stored in variable!</p>} */}

      {/* <button onClick={handleGeneratePdf2}>Generate PDF</button>
      {pdfBlob && (
        <a href={pdfBlob} target="_blank" rel="noopener noreferrer">Download PDF</a>
      )} */}
      {/* <ReactToPdf targetRef={ref} filename="my-document.pdf">
        {({ toPdf }) => (
          <button onClick={toPdf}>Download PDF</button>
        )}
      </ReactToPdf> */}
      {/* <Button onClick={handleReportEmail} variant='danger' className='me-2 mb-1'>Download PDF Report</Button> */}
      
      <div ref={targetRef} id="spreport" style={{ width: '100%' }}>
        {/* <img width='80%' src={logo} alt="logo" /> */}
        
        <span className={"ps-3 ms-2 pull-left text-danger-emphasis display-3 " + (useChartDimensions().isMobile ? 'fs-5' : 'fs-3')}>SELF</span><span className={"text-black " + (useChartDimensions().isMobile ? 'fs-5' : 'fs-3')}>POWERMENT</span> <span className="text-white fs-10 fw-light ps-2">{props.dspversion}</span>
        <p className="text-black fs-10 fw-light ps-4">  {props.contact_name} {props.contact_email} {props.appname} {props.reportdate.toLocaleString()}</p>
        {/* // '<span className="ps-5 fs-3 ms-2 pull-left text-danger-emphasis display-3">SELF</span> <span className="text-black fs-3">POWERMENT</span>' */}

        


        <FalconComponentCard.Header className= {(isMobile ? 'card-title' : 'card-title')} title="" light={false} /> 
          <div className="card-body">
            <p class="h3 mb-5 text-black">SELF ASSESSMENT REPORT</p>
            <p class="h5 text-black">Are you in the Success Trap?</p>
            <p class="h5 text-black fst-italic">A mirror, not a grade.</p>
          </div>
          <ReactEchart
            echarts={echarts}
            option={getAcknowledge()}
            // style={{ minHeight: '5.75rem' }}
            // style={{ height: '100%', width: '100%' }}
            style={{ minHeight: isMobile ? '12.75rem':'15.75rem', height: '100%', width: '100%' }}
            onEvents={{
              resize: (chart) => {
                chart.resize();
              },
            }}
          />
          <ReactEchart
            echarts={echarts}
            option={getAwaken()}
            // style={{ minHeight: '5.75rem' }}
            // style={{ height: '100%', width: '100%' }}
            style={{ minHeight: isMobile ? '8.75rem':'16.75rem', height: '100%', width: '100%' }}
            onEvents={{
              resize: (chart) => {
                chart.resize();
              },
            }}
          />
          <ReactEchart
            echarts={echarts}
            option={getAccept()}
            // style={{ minHeight: '1.75rem' }}
            style={{ minHeight: isMobile ? '8.75rem':'13.75rem', height: '100%', width: '100%' }}
            onEvents={{
              resize: (chart) => {
                chart.resize();
              },
            }}
          />
          <ReactEchart
            echarts={echarts}
            option={getAlign()}
            // style={{ 
            //   // minHeight: '5.75rem', 
            //   height: '300px' 
            // }}
            // style={{ height: '300px', width: '100%' }}
            style={{ minHeight: isMobile ? '12.75rem':'17rem', height: '100%', width: '100%' }}
            onEvents={{
              resize: (chart) => {
                chart.resize();
              },
            }}
            className='mb-5'
          />
          <div className='d-grid gap-2'>
          
          </div>
    <div className={(isMobile ? 'fs-11' : 'fs-9') + " mb-2 text-black text-center"}>
      <p>2026 All Rights Reserved | Deb M. Smallwood LLC | SELFPOWERMENT is a Trademark of Deb M. Smallwood LLC</p>
    </div>
        </div>
        
        
        
        <Button onClick={getTargetElement} variant='danger' className='me-2 fs-6 mb-1'>DOWNLOAD/VIEW PDF</Button>

        
      </FalconComponentCard>
      

        <div>
      
    </div>
      
      </>
    );
  };

export default DSASeriesBarChart;



// TreeMap Explanation:
// Data Structure: The data prop should be an array of objects representing the treemap hierarchy. Each object can have name, value, and children properties. The children array, if present, contains data for the bar chart.
// ECharts Initialization: The useEffect hook initializes the ECharts instance and sets the options.
// Treemap Series: The series option defines the treemap chart.
// Label Formatting: The label.formatter function is key. It renders the node name and calls renderBarChart to create the bar chart SVG. The rich property defines a style for the bar chart.
// Bar Chart Rendering: The renderBarChart function creates a temporary div and initializes an ECharts instance within it. It sets the bar chart options, gets the data URL of the SVG, and disposes of the temporary chart instance.
// Levels: The levels option controls the appearance of different levels in the treemap.
// Component Return: The component returns a div element with a reference for the chart.